import React from 'react';
import './Study.css';
import $ from 'jquery';
import parse from 'html-react-parser';
import Header from '../Header/Header';
import Footer from '../Footer/Footer';
import { FcInfo } from "react-icons/fc";
import Spinner from '../Spinner/Spinner';
import { withRouter } from "react-router";
import { post } from '../../app/shared/http';
import { withAuth } from "../../app/util/HOC";
import StudyCenterHeader from './StudyCenterHeader';
import ProgressBar from 'react-bootstrap/ProgressBar';
import { handleException } from "../../app/util/util";
import loaderColors1 from '../Spinner/loaderColors1.gif';
var userVORole;
const chapters = ['Property Fall 2020', 'Iron Dwarf', 'Highborn Human', 'Lowland Human', 'Mountain Dwarf', 'Scythian Elf', 'Woodland Elf'];
let questionType = "", questionTypeLabel = "";
export class StudyShortAnswerProfessor extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            progress: 50,
            learningObjectiveProgressVOList: [],
            chapterNavTitle: "",
            bookISBN: "",
            bookTitle: "",
            backtoStudyCenter: false,
            classVOList: null,
            questionBankVOList: null,
            totalNumberOfStudents: null,
            learningObjName: "",
            bookVO: JSON.parse(localStorage.getItem('bookVO')),
            userVO: JSON.parse(localStorage.getItem('userVO')),
            keepMeLogIn: localStorage.getItem('keepLoggedIn') ? "true" : "false",
            loading: false,
            isEndorseLoading: false
        };
    }
    componentDidMount = () => {
        questionType = this.props.match.path.split('/')[4];
        if (questionType === "shortanswerreview") {
            questionType = "hypothetical";
            questionTypeLabel = "Short Answer Questions"
        }
        else if (questionType === "essayreview") {
            questionType = "essay";
            questionTypeLabel = "Essay Questions"
        }
        this.getClassDetails();
    }
    componentWillUnmount() { }
    componentDidUpdate = (prevProps, prevState) => {
        if (this.props.match.params.chapterid !== prevProps.match.params.chapterid) {
            this.getClassDetails();
        }
    }
    getClassDetails() {
        userVORole = this.state.userVO.userRole;
        let reqData = {
            "userVO": {
                "userId": this.state.userVO.userId,
                "userRole": this.state.userVO.userRole,
                "userRoleId": this.state.userVO.userRoleId,
                "userActivityVO": {
                    "lastActivityCode": "BOOKSHELF",
                    "pageNavigatingFrom": "StudyCenter",
                    "pageNavigatingTo": "StudyCenterQuestion"
                },
                "sessionVO": {
                    "appType": "web",
                    "deviceMacId": "",
                    "deviceOS": localStorage.getItem('deviceOS'),
                    "keepMeLoggedInFlag": this.state.keepMeLogIn,
                    "deviceType": localStorage.getItem('deviceType'),
                    "browserName": localStorage.getItem('browserName'),
                    "sessionAuthenticationToken": this.state.userVO.sessionAuthenticationToken,
                },
            },
            "bookVO": {
                "bookISBN": this.props.match.params.isbn
            }
        }
        const requestOptions1 = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify(reqData)
        };
        this.setState({ "loading": true })
        fetch(localStorage.getItem('ENV') + "/manageClassWebService/getAllClassByIsbn", requestOptions1)
            .then(response => response.json())
            .then(data => {
                if (data) {
                    if (data.status === "true") {
                        var bookVO = data.bookVO, classVOList = (Array.isArray(data.classVOList) ? data.classVOList : [data.classVOList]);
                        let reqData = {
                            "userVO": {
                                "userId": this.state.userVO.userId,
                                "userRole": this.state.userVO.userRole,
                                "userRoleId": this.state.userVO.userRoleId,
                                "userActivityVO": {
                                    "lastActivityCode": "BOOKSHELF",
                                    "pageNavigatingTo": "BOOKSHELF",
                                    "lastViewedLearningObjectId": "",
                                    "pageNavigatingFrom": "BOOKSHELF",
                                },
                                "sessionVO": {
                                    "appType": "web",
                                    "deviceMacId": "",
                                    "keepMeLoggedInFlag": this.state.keepMeLogIn,
                                    "deviceOS": localStorage.getItem('deviceOS'),
                                    "deviceType": localStorage.getItem('deviceType'),
                                    "browserName": localStorage.getItem('browserName'),
                                    "sessionAuthenticationToken": this.state.userVO.sessionAuthenticationToken,
                                },
                            },
                            "bookVO": {
                                "bookISBN": this.props.match.params.isbn
                            },
                            "questionVO": {
                                "questionType": questionType,
                                "bookISBN": this.props.match.params.isbn,
                                "chapterId": this.props.match.params.chapterid,
                                "learningObjectId": this.props.match.params.loid
                            }
                        }
                        var selectedClassId, selectedClassName;
                        if (this.state.userVO.userRoleId === "5") {
                            reqData.questionVO.classId = "-999"
                        } else {
                            var classId = this.props.history.location.hash.replace("#", "")
                            if (classId !== undefined && classId !== null && parseInt(classId) > 0) {
                                reqData.questionVO.classId = classId
                                selectedClassId = classId
                                if (classVOList !== undefined && classVOList !== null && classVOList.length > 0
                                    && classVOList[0] !== undefined) {
                                    for (var i = 0; i < classVOList.length; i++) {
                                        if (classVOList[i].classId === classId) {
                                            selectedClassName = classVOList[i].className
                                            break;
                                        }
                                    }
                                }
                            } else {
                                if (classVOList !== undefined && classVOList !== null && classVOList.length > 0
                                    && classVOList[0] !== undefined) {
                                    reqData.questionVO.classIdO = classVOList[0].classId
                                    selectedClassId = classVOList[0].classId
                                    selectedClassName = classVOList[0].className
                                }
                            }
                        }
                        const requestOptions1 = {
                            method: 'POST',
                            body: JSON.stringify(reqData),
                            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                        };
                        fetch(localStorage.getItem('ENV') + "/assessmentRetrievalService/getQuestionForStudyCenterLearnRv", requestOptions1)
                            .then(response => response.json())
                            .then(data => {
                                if (data) {
                                    if (data.status === "true") {
                                        if (data.assessmentVO && data.assessmentVO.questionBankVOList) {
                                            var questionBankVOList = Array.isArray(data.assessmentVO.questionBankVOList) ? data.assessmentVO.questionBankVOList : [data.assessmentVO.questionBankVOList]
                                            this.setState({
                                                "questionBankVOList": questionBankVOList, "totalQuestions": data.assessmentVO.countOfTotalQuestion,
                                                "bookVO": bookVO, "totalNumberOfStudents": data.numberOfEnrolledStudent,
                                                "learningObjName": data.learningObjName, "classVOList": classVOList, "haveText": selectedClassName,
                                                "currentClassId": selectedClassId, "loading": false
                                            });
                                            this.loadImagesFromCDN();
                                        }
                                    } else {
                                        this.setState({
                                            "bookVO": bookVO, "learningObjName": data.learningObjName,
                                            "classVOList": classVOList, "haveText": selectedClassName,
                                            "currentClassId": selectedClassId, "loading": false
                                        })
                                        if (data.wkErrorCode) {
                                            handleException(data);
                                        }
                                    }
                                }
                            }).catch(error => {
                                console.error("There has been a problem with your fetch operation:", error);
                                this.setState({ "loading": false });
                            });
                    } else {
                        if (data.wkErrorCode) {
                            handleException(data);
                        }
                    }
                }
            }).catch(error => {
                this.setState({ "loading": false })
                console.error("There has been a problem with your fetch operation:", error);
            });
    }
    loadImagesFromCDN = () => {
        let relativeUrl = "", imgInChapter = [], i = 0, imgTags = "";
        imgInChapter = document.querySelectorAll('#studyProfShortAnswerContainer img');
        imgTags = imgInChapter;
        if (imgInChapter != undefined) {
            for (i = 0; i < imgInChapter.length; i++) {
                relativeUrl = `/casebook/questionimages${imgInChapter[i].src.split('/questionimages')[1]}`;
                relativeUrl = relativeUrl.split('?')[0];
                let reqData = { "genericServiceRequestVO": { "inputBaseUrl": relativeUrl } };
                post("/manageUrlService/getCDNUrl", reqData, "ENV")
                    .then(response => response.json())
                    .then(data => {
                        if (data.status === "true") {
                            for (i = 0; i < imgTags.length; i++) {
                                if (data.genericServiceResponseVO.cdnUrl.indexOf(imgTags[i].src.split('/questionimages')[1]) != -1) {
                                    imgTags[i].src = data.genericServiceResponseVO.cdnUrl;
                                    imgTags[i].style.maxHeight = "250px";
                                    imgTags[i].style.maxWidth = "100%";
                                }
                            };
                        } else if (data.wkErrorCode) {
                            handleException(data);
                        }
                    }).catch(error => {
                        console.error("There has been a problem with your fetch operation:", error);
                    });
            }
        }
    }
    endorseQuestion = (e) => {
        if (e.currentTarget.getAttribute("questionid")) {
            var index = e.currentTarget.getAttribute("index")
            var endorseQuestionFlag = e.currentTarget.getAttribute("endorseQuestionFlag")
            let reqData = {
                "userVO": {
                    "userId": this.state.userVO.userId,
                    "userRole": this.state.userVO.userRole,
                    "userRoleId": this.state.userVO.userRoleId,
                    "userActivityVO": {
                        "lastActivityCode": "BOOKSHELF",
                        "pageNavigatingTo": "BOOKSHELF",
                        "pageNavigatingFrom": "BOOKSHELF",
                    },
                    "sessionVO": {
                        "appType": "web",
                        "deviceMacId": "",
                        "keepMeLoggedInFlag": this.state.keepMeLogIn,
                        "deviceOS": localStorage.getItem('deviceOS'),
                        "deviceType": localStorage.getItem('deviceType'),
                        "browserName": localStorage.getItem('browserName'),
                        "sessionAuthenticationToken": this.state.userVO.sessionAuthenticationToken,
                    },
                },
                "questionVO": {
                    "questionId": e.currentTarget.getAttribute("questionid"),
                    "endorseQuestionFlag": e.currentTarget.getAttribute("endorseQuestionFlag")
                }
            }
            const requestOptions1 = {
                method: 'POST',
                body: JSON.stringify(reqData),
                headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            };
            this.setState({ "isEndorseLoading": true })
            fetch(localStorage.getItem('ENV') + "/manageAssessmentService/endorseQuestion", requestOptions1)
                .then(response => response.json())
                .then(data => {
                    if (data.status === "true") {
                        if (data) {
                            $("#endorse_yes" + index).removeClass("endorse_rtActive endorse_back")
                            $("#endorse_no" + index).removeClass("doNotDisturb_rtActive notendorse_back")
                            $("#neutral_" + index).removeClass("neutral_rtActive neutral_back")
                            $("#endorse_yes" + index).attr("aria-selected", "false");
                            $("#endorse_no" + index).attr("aria-selected", "false");
                            $("#neutral_" + index).attr("aria-selected", "false");
                            switch (endorseQuestionFlag) {
                                case "2":
                                    $("#neutral_" + index).addClass("neutral_rtActive neutral_back");
                                    $("#neutral_" + index).attr("aria-selected", "true");
                                    break;
                                case "0":
                                    $("#endorse_no" + index).addClass("doNotDisturb_rtActive notendorse_back")
                                    $("#endorse_no" + index).attr("aria-selected", "true");
                                    break;
                                case "1":
                                    $("#endorse_yes" + index).addClass("endorse_rtActive endorse_back")
                                    $("#endorse_yes" + index).attr("aria-selected", "true");
                                    break;
                                default:
                                    break;
                            }
                        }
                        this.setState({ "isEndorseLoading": false })
                    } else {
                        if (data.wkErrorCode) {
                            handleException(data);
                        }
                    }
                }).catch(error => {
                    this.setState({ "isEndorseLoading": false })
                    console.error("There has been a problem with your fetch operation:", error);
                });
        }
    }
    /* HS -  CC-5466 Prof. ExpandAll feature */
    expandStudyQuestion = (e) => {
        var expandBtn = document.getElementById('fromStudyQuestionId_rt' + e.currentTarget.value);
        if (e.currentTarget.innerText === "Expand") {
            e.currentTarget.innerText = "Collapse";
            e.currentTarget.setAttribute('aria-label', `Collapse question ${parseInt(e.currentTarget.value) + 1}`);
            expandBtn.classList.remove("studyQuestionEllipsis");
            expandBtn.classList.add("studyQuestionNonEllipsis");
        } else {
            e.currentTarget.innerText = "Expand";
            e.currentTarget.setAttribute('aria-label', `Expand question ${parseInt(e.currentTarget.value) + 1}`);
            expandBtn.classList.remove("studyQuestionNonEllipsis");
            expandBtn.classList.add("studyQuestionEllipsis");
        }
    }
    /* HS -  CC-5466 Prof. ExpandAll feature */
    expandStudyQuestionAll = (e) => {
        var expandBtn = document.getElementsByName('fromStudyQuestion_all');
        var expandstudybtn = document.getElementsByName('studyExpandBtnId_all');
        if (e.currentTarget.innerText === "Expand All") {
            for (var i = 0; i < expandBtn.length; i++) {
                document.getElementById('btnexpand_' + i).setAttribute('aria-label', `Collapse question ${parseInt(i) + 1}`);
                expandBtn[i].classList.remove("studyQuestionEllipsis");
                expandBtn[i].classList.add("studyQuestionNonEllipsis");
                document.getElementById('btnexpand_' + i).innerText = "Collapse";
            }
            for (var j = 0; j < expandstudybtn.length; j++) {
                expandstudybtn[j].classList.add("show");
            }
        } else {
            for (var i = 0; i < expandBtn.length; i++) {
                document.getElementById('btnexpand_' + i).setAttribute('aria-label', `Expand question ${parseInt(i) + 1}`);
                expandBtn[i].classList.remove("studyQuestionNonEllipsis");
                expandBtn[i].classList.add("studyQuestionEllipsis");
                document.getElementById('btnexpand_' + i).innerText = "Expand";
            }
            for (var j = 0; j < expandstudybtn.length; j++) {
                expandstudybtn[j].classList.remove("show");
            }
        }
    }
    handleClick = () => {
        this.setState({
            isOpen: !this.state.isOpen
        });
    }
    handleText = (ev) => {
        var classId = ev.currentTarget.getAttribute("classId");
        var className = ev.currentTarget.textContent;
        if (ev.currentTarget.getAttribute("classId")) {
            let reqData2 = {
                "userVO": {
                    "userId": this.state.userVO.userId,
                    "userRole": this.state.userVO.userRole,
                    "userRoleId": this.state.userVO.userRoleId,
                    "userActivityVO": {
                        "lastActivityCode": "BOOKSHELF",
                        "pageNavigatingTo": "BOOKSHELF",
                        "pageNavigatingFrom": "BOOKSHELF",
                    },
                    "sessionVO": {
                        "appType": "web",
                        "deviceMacId": "",
                        "keepMeLoggedInFlag": this.state.keepMeLogIn,
                        "deviceOS": localStorage.getItem('deviceOS'),
                        "deviceType": localStorage.getItem('deviceType'),
                        "browserName": localStorage.getItem('browserName'),
                        "sessionAuthenticationToken": this.state.userVO.sessionAuthenticationToken,
                    },
                },
                "bookVO": {
                    "classId": classId,
                    "bookId": this.state.bookVO.bookId,
                    "bookISBN": this.props.match.params.isbn
                },
                "questionVO": {
                    "classId": classId,
                    "questionType": "flashcard",
                    "bookISBN": this.props.match.params.isbn,
                    "chapterId": this.props.match.params.chapterid,
                    "learningObjectId": this.props.match.params.loid
                }
            }
            const requestOptions2 = {
                method: 'POST',
                body: JSON.stringify(reqData2),
                headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            };
            fetch(localStorage.getItem('ENV') + "/assessmentRetrievalService/getQuestionForStudyCenterLearnRv", requestOptions2)
                .then(response => response.json())
                .then(data => {
                    if (data) {
                        if (data.status === "true" && data.assessmentVO) {
                            var questionBankVOList = Array.isArray(data.assessmentVO.questionBankVOList) ? data.assessmentVO.questionBankVOList : [data.assessmentVO.questionBankVOList]
                            this.setState({
                                "questionBankVOList": questionBankVOList, "totalQuestions": data.assessmentVO.countOfTotalQuestion,
                                "bookVO": data.bookVO, "totalNumberOfStudents": data.numberOfEnrolledStudent,
                                "learningObjName": data.learningObjName, "haveText": className,
                                "currentClassId": classId
                            })
                        } else {
                            this.setState({
                                "bookVO": data.bookVO, "learningObjName": data.learningObjName, "haveText": className,
                                "currentClassId": classId
                            })
                            if (data.wkErrorCode) {
                                handleException(data);
                            }
                        }
                    }
                }).catch(error => {
                    console.error("There has been a problem with your fetch operation:", error);
                });
        }
    }
    navigateToChapterInsights = (e) => {
        this.props.history.push(`/study/${this.props.match.params.isbn}/${this.props.match.params.chapterid}`);
    }
    navigateToStudyDashboard = (e) => {
        this.props.history.push(`/study/${this.props.match.params.isbn}`);
    }
    handleBackToStudyCenter = (e) => {
        if (e.key === 'Enter') {
            this.navigateToStudyDashboard();
        }
    }
    handleNavigateToChapterInsights = (e) => {
        if (e.key === 'Enter') {
            this.navigateToChapterInsights();
        }
    }
    render() {
        let itemList = props => {
            var schoolList = this.state.classVOList;
            if (schoolList !== undefined && schoolList !== null && schoolList.length > 0 && schoolList[0] !== undefined) {
                const list = schoolList.map((item) => (
                    <div
                        onClick={this.handleText}
                        className="dropdown__item" classId={item.classId}
                        key={item.classId} classCode={item.classCode}>
                        {item.className}
                    </div>
                ));
                return (
                    <div className="dropdown__items"> {list} </div>
                )
            }
        }
        let decimalFormat = (value) => {
            if (!isNaN(value))
                return parseFloat(value % 1 === 0 ? Math.round(value) : value.toFixed(2))
        }
        let getProgressBar = (question) => {
            let questionResponseVO = question.questionResponseVO;
            var correct = decimalFormat((parseInt(questionResponseVO.numberOfCorrectResponse) / parseInt(this.state.totalNumberOfStudents)) * 100);
            var incorrect = decimalFormat((parseInt(questionResponseVO.numberOfInCorrectResponse) / parseInt(this.state.totalNumberOfStudents)) * 100);
            var partial = decimalFormat((parseInt(questionResponseVO.numberOfPartialCorrectResponse) / parseInt(this.state.totalNumberOfStudents)) * 100);
            partial = isNaN(partial) ? 0 : partial;
            incorrect = isNaN(incorrect) ? 0 : incorrect;
            correct = isNaN(correct) ? 0 : correct;
            var unans = (decimalFormat(partial + incorrect + correct) === 99.99) ? 100 : decimalFormat(partial + incorrect + correct);
            return <div>
                <div className="multicolor-bar">
                    <ProgressBar>
                        <ProgressBar className="progress-greenColor" aria-label={`Question ${question.questionNumber}: percentage of students who answered correctly`} now={correct} key={1} />
                        <ProgressBar className="progress-redColor" aria-label={`Question ${question.questionNumber}: percentage of students who answered incorrectly`} now={incorrect} key={2} />
                        <ProgressBar className="progress-blueColor" aria-label={`Question ${question.questionNumber}: percentage of students who need practice`} now={partial} key={3} />
                        <ProgressBar className="progress-greyColor" aria-label={`Question ${question.questionNumber}: percentage of students who did not answer`} now={(100 - unans)} key={4} />
                    </ProgressBar>
                </div>
                <div className="questionRsultsTitle mTopFive">
                    <span>Student Total: </span>
                    <span>{correct}% correct</span> <span className="pipeLine_rt">|</span>
                    <span>{incorrect}% incorrect</span> <span className="pipeLine_rt">|</span>
                    <span>{partial}% needs practice</span> <span className="pipeLine_rt">|</span>
                    <span>{(100 - unans)}% unanswered</span>
                </div>
            </div>
        }
        return (
            <React.Fragment>
                <Header userVO={this.state.userVO} bookVO={this.state.bookVO} pageName="study" ></Header>
                <StudyCenterHeader userVO={this.state.userVO} />
                <div className="col-lg-12 col-md-12 col-sm-12">
                    <div className="row greyDiv">
                        <div className="col-lg-8 col-md-6 col-sm-12 headingDiv studyMarginHead">
                            <span className="insightProperty">{this.state.learningObjName ? this.state.learningObjName : ""}</span><br />
                            <span className="insightHeading">  {questionTypeLabel}   </span>
                            <div style={{ display: 'flex' }}>
                                <span className="studyLink cusorPointer" onClick={this.navigateToStudyDashboard} tabIndex="0" onKeyDown={(e) => this.handleBackToStudyCenter(e)}> Back to Study Center </span>
                                {userVORole == "Professor" ?
                                    <div style={{ display: 'contents' }}>
                                        <i className="fa fa-angle-right" aria-hidden="true" style={{ padding: '0% 1%', fontWeight: 'bold', fontSize: '14px' }}></i>
                                        <span className="studyLink cusorPointer" onClick={this.navigateToChapterInsights} tabIndex="0" onKeyDown={(e) => this.handleNavigateToChapterInsights(e)}> Chapter Insights</span>
                                    </div>
                                    :
                                    null
                                }
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 col-sm-12 viewhead" style={{ display: 'inline-flex', justifyContent: 'center', margin: 'auto' }}>
                            <span className="insightProperty">View results for:</span>
                            <a data-testid="select_chapter" className="fontAwesomeBlackColor" href="javascript:void(0)" onClick={this.handleClick}>
                                <div
                                    className={this.state.isOpen ? "dropdown active IphoneMargin" : "dropdown IphoneMargin"}
                                    style={{ marginLeft: '15px', background: '#FFFFFF 0% 0% no-repeat padding-box', border: '1px solid #000000', zIndex: '999' }}>
                                    <div className="dropdown__text">
                                        <div className="textOverflowClass">  {!this.state.haveText ? "Select Class" : this.state.haveText} </div>
                                    </div>
                                    {itemList(chapters)}
                                </div>
                            </a>
                        </div>
                    </div>
                </div>
                <div className="studyDivDhonutShowBlock col-lg-8 col-md-8 col-sm-8 col-xs-8 mx-auto no-padding mTopTwnty">
                    <Spinner
                        loading={this.state.loading || this.state.isEndorseLoading}
                        imageSrc={loaderColors1}
                        overlayBackground="rgba(0,0,0,0.5)"
                        label={this.state.isEndorseLoading ? "Saving your preference" : "Loading short answer questions"}
                    />
                    <div className="studyDivDhonut">
                        <div id="studyProfShortAnswerContainer" className="row">
                            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding mBottomTwenty">
                                <div className="col-lg-4 col-md-5 col-sm-12 pull-right display-inline-block" style={{ position: 'relative', top: '40%' }}>
                                    <button className="expandAll_rt" onClick={this.expandStudyQuestionAll}>Expand All</button>
                                    <span className="pipeLine_rt">|</span>
                                    <button className="collapseAll_rt" onClick={this.expandStudyQuestionAll}>Collapse All</button>
                                </div>
                            </div>
                            {this.state.questionBankVOList ? this.state.questionBankVOList.map((question, index) => (
                                <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 mTopTwnty no-padding">
                                    <div className="col-lg-1 col-md-1 col-sm-1 col-xs-1 no-padding display-inline-block" style={{ background: '#ECECEC', width: '50px', height: '50px', borderRadius: '5px' }}>
                                        <span className="studyNumberSection_rt">{question.questionNumber}</span>
                                    </div>
                                    <div className="col-lg-9 col-md-9 col-sm-9 col-xs-9 display-inline-block addWidth">
                                        <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding display-inline-block">
                                            {
                                                (
                                                    question.questionVO && question.questionVO.studyAidVOList && !Array.isArray(question.questionVO.studyAidVOList)
                                                    && question.questionVO.studyAidVOList.studyAidTitle && question.questionVO.studyAidVOList.studyAidLink
                                                ) ?
                                                    <div className="fromChapterTitleBlk_rt">
                                                        <span>From
                                                            <span className="fromChapterTitle_rt">
                                                                &nbsp; <a href={question.questionVO.studyAidVOList.studyAidLink} target="__blank">
                                                                    {question.questionVO.studyAidVOList.studyAidTitle}
                                                                </a>
                                                            </span>
                                                        </span>
                                                    </div> : null
                                            }
                                            <div id={"fromStudyQuestionId_rt" + index} name="fromStudyQuestion_all" className="fromStudyQuestion_rt mTopTen studyQuestionEllipsis">
                                                {parse(question.questionVO.questionText)}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-1 col-md-1 col-sm-1 col-xs-1 display-inline-block  studyExpandCollapseId" style={{ width: '80px' }}>
                                        <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12" style={{ paddingLeft: '55px' }}>
                                            <button type="button"
                                                id={"btnexpand_" + index}
                                                className="btn btn-primary btnNavyBluePrimary pull-right"
                                                data-toggle="collapse"
                                                data-target={"#studyExpandBtnId_" + index}
                                                aria-expanded="false"
                                                aria-label={"Expand question " + (parseInt(index) + 1)} 
                                                aria-controls={"studyExpandBtnId_" + index}
                                                value={index}
                                                onClick={this.expandStudyQuestion}>
                                                Expand
                                            </button>
                                        </div>
                                    </div>
                                    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding">
                                        <div className="col-lg-1 col-md-1 col-sm-1 col-xs-1 no-padding display-inline-block" style={{ width: '50px', height: '50px' }} />
                                        <div className="col-lg-9 col-md-9 col-sm-9 col-xs-9 display-inline-block addWidth">
                                            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding display-inline-block">
                                                <div id={"studyExpandBtnId_" + index} name="studyExpandBtnId_all" className="studyExpandedBlock_rt collapse hide">
                                                    <div id={"studyExpandBtnId_" + index} name="studyExpandBtnId_all" className="studyExpandedBlock_rt collapse hide">
                                                        <div className="endorseBlock mTopTwnty">
                                                            <div className="">
                                                                Do you want to endorse this question?
                                                                <FcInfo className="fcIconBtn" style={{ marginLeft: '5px' }} />
                                                            </div>
                                                            <div className="">
                                                                <button type="button" onClick={this.endorseQuestion} aria-label={`Endorse question ${parseInt(index) + 1}`} id={"endorse_yes" + index} index={index} questionid={question.questionVO.questionId} endorseQuestionFlag="1" aria-selected={(question.questionResponseVO.endorseQuestionFlag === "1") ? "true" : "false"} className={question.questionResponseVO.endorseQuestionFlag === "1" ? "btn btn-outline-primary btnEndorseBlock mTopTen hoverEndorseClass endorse_rtActive endorse_back" : "btn btn-outline-primary btnEndorseBlock mTopTen hoverEndorseClass"}>Endorse</button>
                                                                <button type="button" onClick={this.endorseQuestion} aria-label={`Do Not Endorse question ${parseInt(index) + 1}`} id={"endorse_no" + index} index={index} questionid={question.questionVO.questionId} endorseQuestionFlag="0" aria-selected={(question.questionResponseVO.endorseQuestionFlag === "0") ? "true" : "false"} className={question.questionResponseVO.endorseQuestionFlag === "0" ? "btn btn-outline-primary btnEndorseBlock mTopTen hoverEndorseClass doNotDisturb_rtActive notendorse_back" : "btn btn-outline-primary btnEndorseBlock mTopTen hoverEndorseClass"}>Do Not Endorse</button>
                                                                <button type="button" onClick={this.endorseQuestion} aria-label={`Neutral question ${parseInt(index) + 1}`} id={"neutral_" + index} index={index} questionid={question.questionVO.questionId} endorseQuestionFlag="2" aria-selected={(question.questionResponseVO.endorseQuestionFlag === "2") ? "true" : "false"} className={question.questionResponseVO.endorseQuestionFlag === "2" ? "btn btn-outline-primary btnEndorseBlock mTopTen hoverEndorseClass neutral_rtActive neutral_back" : "btn btn-outline-primary btnEndorseBlock mTopTen hoverEndorseClass"}>Neutral</button>
                                                            </div>
                                                        </div>
                                                        <div className="mTopTwnty">
                                                            <div className="rationaleTitle_rt">Answer</div>
                                                            <div className="rationaleCorrectAns_rt mTopTen">
                                                                {parse(question.questionVO.generalFeedback)}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="questionRsultsTitle mTopFifteen">Question Results</div>
                                                <div className="multicolor-bar">
                                                    {getProgressBar(question)}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="clearfix mTopTwnty mBottomTwnty borderBottom"></div>
                                </div>
                            )) : null}
                            {/* [HS] CC-5625  - Add disclaimer at the end of the page  */}
                            <br />
                            <div>
                                <span className="insightHeading">
                                    About the Connected eBook Study Center
                                </span>
                                <br /> <br />
                                <span className="insightProperty">
                                    The content in the Study Center is selected and maintained exclusively by Aspen Publishing and a team of professor reviewers and editors, not by the authors of your book. These materials typically come from one or more of Aspen Publishing's top study aids, including Examples & Explanations, Glannon Guides, Emanuel Law Outlines, and Emanuel Law in a Flash, or may be created with assistance from AI tools. Study material sources and activity types vary depending on availability for any given chapter, topic, or course.
                                </span>
                            </div>
                            <br />
                        </div>
                    </div>
                </div>
                <Footer />
            </React.Fragment>
        );
    }
}
export default withAuth(withRouter(StudyShortAnswerProfessor));